
import { Helmet } from "react-helmet";
import FilterGalarryOne from "../components/common/filter-gallary/filter-gallary-one";
import CardSliderOne from "../components/common/sliders/card/card-slider-one";
import TextSliderTwo from "../components/common/sliders/text/text-slider-two";
import HeroSection from "../components/home-three/hero-section";
import NewsLetter from "../components/home-three/news-letter";
import NftRoadMap from "../components/home-three/nft-roadmap";
import Team from "../components/home-three/Team";

export default function HomeThree() {
	return (
		<>
			<Helmet>
				<title>fugu - index -03</title>
			</Helmet>
			<HeroSection />
			<CardSliderOne />
			<FilterGalarryOne />
			<TextSliderTwo />
			<Team />
			<NftRoadMap />
			<NewsLetter />
		</>
	);
}
